import { render, staticRenderFns } from "./ImpersonateUser.vue?vue&type=template&id=5144023a&"
import script from "./ImpersonateUser.vue?vue&type=script&lang=js&"
export * from "./ImpersonateUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports